// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  OperationResource,
  ErrorModel,
  ErrorAdditionalInfo,
  CloudError,
  Vault,
  VaultProperties,
  UpgradeDetails,
  KnownVaultUpgradeState,
  VaultUpgradeState,
  KnownTriggerType,
  TriggerType,
  PrivateEndpointConnectionVaultProperties,
  PrivateEndpointConnection,
  KnownProvisioningState,
  ProvisioningState,
  PrivateEndpoint,
  PrivateLinkServiceConnectionState,
  KnownPrivateEndpointConnectionStatus,
  PrivateEndpointConnectionStatus,
  KnownVaultSubResourceType,
  VaultSubResourceType,
  KnownVaultPrivateEndpointState,
  VaultPrivateEndpointState,
  VaultPropertiesEncryption,
  CmkKeyVaultProperties,
  CmkKekIdentity,
  KnownInfrastructureEncryptionState,
  InfrastructureEncryptionState,
  VaultPropertiesMoveDetails,
  KnownResourceMoveState,
  ResourceMoveState,
  KnownBackupStorageVersion,
  BackupStorageVersion,
  KnownPublicNetworkAccess,
  PublicNetworkAccess,
  MonitoringSettings,
  AzureMonitorAlertSettings,
  KnownAlertsState,
  AlertsState,
  ClassicAlertSettings,
  RestoreSettings,
  CrossSubscriptionRestoreSettings,
  KnownCrossSubscriptionRestoreState,
  CrossSubscriptionRestoreState,
  VaultPropertiesRedundancySettings,
  KnownStandardTierStorageRedundancy,
  StandardTierStorageRedundancy,
  KnownCrossRegionRestore,
  CrossRegionRestore,
  SecuritySettings,
  ImmutabilitySettings,
  KnownImmutabilityState,
  ImmutabilityState,
  SoftDeleteSettings,
  KnownSoftDeleteState,
  SoftDeleteState,
  KnownEnhancedSecurityState,
  EnhancedSecurityState,
  KnownMultiUserAuthorization,
  MultiUserAuthorization,
  SourceScanConfiguration,
  KnownState,
  State,
  AssociatedIdentity,
  KnownIdentityType,
  IdentityType,
  KnownSecureScoreLevel,
  SecureScoreLevel,
  KnownBcdrSecurityLevel,
  BcdrSecurityLevel,
  IdentityData,
  KnownResourceIdentityType,
  ResourceIdentityType,
  UserIdentity,
  Sku,
  KnownSkuName,
  SkuName,
  TrackedResource,
  Resource,
  SystemData,
  KnownCreatedByType,
  CreatedByType,
  ClientDiscoveryValueForSingleApi,
  ClientDiscoveryDisplay,
  ClientDiscoveryForProperties,
  ClientDiscoveryForServiceSpecification,
  ClientDiscoveryForLogSpecification,
  ErrorDetail,
  PatchVault,
  PatchTrackedResource,
  ErrorResponse,
  DeletedVault,
  DeletedVaultProperties,
  ProxyResource,
  DeletedVaultUndeleteInput,
  DeletedVaultUndeleteInputProperties,
  PrivateLinkResource,
  PrivateLinkResourceProperties,
  CertificateRequest,
  RawCertificateData,
  KnownAuthType,
  AuthType,
  VaultCertificateResponse,
  ResourceCertificateDetails,
  ResourceCertificateDetailsUnion,
  ResourceCertificateAndAadDetails,
  ResourceCertificateAndAcsDetails,
  ReplicationUsage,
  MonitoringSummary,
  JobsSummary,
  VaultUsage,
  KnownUsagesUnit,
  UsagesUnit,
  NameInfo,
  VaultExtendedInfoResource,
  VaultExtendedInfo,
  CheckNameAvailabilityParameters,
  CheckNameAvailabilityResult,
  ResourceCapabilities,
  CapabilitiesProperties,
  DNSZone,
  ResourceCapabilitiesBase,
  CapabilitiesResponse,
  CapabilitiesResponseProperties,
  DNSZoneResponse,
  KnownVersions,
} from "./models.js";
